import getCalendarViewService from '../services/getCalendarViewService';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { orchestrator } from 'satcheljs';
import getNextMeeting from '../selectors/getNextMeeting';
import { updateNextMeetingInformation } from '../actions/internalActions';
import { initializeUpNext, onCalendarNotification } from '../actions/publicActions';
import { addCalendarItemsToStore } from '../actions/internalActions';
import HierarchyNotificationPayload from 'owa-service/lib/contract/HierarchyNotificationPayload';
export { HierarchyNotificationPayload };

const NUMBER_OF_DAYS_TO_LOAD = 2;

export const refreshCalendarEventsOrchstrator = orchestrator(
    onCalendarNotification,
    actionMessage => {
        loadCalendarEvents();
    }
);

export const initializeCalendarEventsOrchestrator = orchestrator(
    initializeUpNext,
    actionMessage => {
        loadCalendarEvents();
    }
);

function loadCalendarEvents() {
    // 1 millisecond so we are really at the beginning of today.
    const today = new Date();
    today.setHours(0, 0, 0, 1);

    const queryStart = today;

    const queryEnd = new Date(today); // today + NUMBER_OF_DAYS_TO_LOAD
    queryEnd.setDate(queryStart.getDate() + NUMBER_OF_DAYS_TO_LOAD);

    // TODO: Task 538: Handle failure from the server call
    return getCalendarViewService(queryStart, queryEnd).then((items: CalendarItem[]) => {
        if (!items) {
            return;
        }
        addCalendarItemsToStore(items);
        const nextMeeting = getNextMeeting();
        updateNextMeetingInformation(nextMeeting);
    });
}
